import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../components/Icon';
import DevNotice from '../components/DevNotice';
import StatCard from './components/StatCard';
import SalesPerformance from './components/SalesPerformance';
import RevenueBreakdown from './components/RevenueBreakdown';
import RecentTransactions from './components/RecentTransactions';
import TopProducts from './components/TopProducts';
import CustomerInsights from './components/CustomerInsights';
import { KPI_CARDS } from './mockData';
import './statistics.css';

// Страница «Статистика» (/statistics). Пока полностью на моках из mockData.js —
// вся вёрстка и стили лежат в этой папке, чтобы модуль легко переносился.
const StatisticsPage = () => {
  const { t } = useTranslation();

  return (
  <div className="stats-page">
    <header className="stats-page-head">
      <div>
        <h1 className="stats-page-title">{t('statistics.title')}</h1>
        <p className="stats-page-subtitle">{t('statistics.subtitle')}</p>
      </div>
      <div className="stats-page-actions">
        <button type="button" className="stats-btn stats-btn--primary">
          <Icon name="plus" size={16} />
          {t('statistics.newReport')}
        </button>
        <button type="button" className="stats-btn">
          <Icon name="settings" size={16} />
          {t('statistics.actions')}
        </button>
      </div>
    </header>

    <DevNotice />

    <div className="stats-kpi-grid">
      {KPI_CARDS.map((card) => (
        <StatCard key={card.id} {...card} />
      ))}
    </div>

    <div className="stats-grid-2">
      <SalesPerformance />
      <RevenueBreakdown />
    </div>

    <div className="stats-grid-2">
      <RecentTransactions />
      <TopProducts />
    </div>

    <CustomerInsights />
    </div>
  );
};

export default StatisticsPage;
